import { render, staticRenderFns } from "./EditWishlist.vue?vue&type=template&id=52ead497&scoped=true"
import script from "./EditWishlist.vue?vue&type=script&lang=js"
export * from "./EditWishlist.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52ead497",
  null
  
)

export default component.exports